import {
    GETUPDATECONFIGURATIONADMIN_SUCCESS,
    GETUPDATECONFIGURATIONADMIN_FAILED,
    RESET_GETUPDATECONFIGURATIONADMIN,
    LOADING_GETUPDATECONFIGURATIONADMIN,
    NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN,
} from "../types/index";

import { adminServices } from "../../config/axios";

const resetGetUpdateConfigurationAdmin = () => {
    return { type: RESET_GETUPDATECONFIGURATIONADMIN };
};

const getUpdateConfigurationAdminList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETUPDATECONFIGURATIONADMIN });
        await adminServices
            .post("getUpdateConfigurationAdmin", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getUpdateConfigurationAdminSuccess(res.data));
                        break;
                    default:
                        dispatch(getUpdateConfigurationAdminFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETUPDATECONFIGURATIONADMIN,
                    payload: err,
                });
            });

        function getUpdateConfigurationAdminSuccess(data) {
            return {
                type: GETUPDATECONFIGURATIONADMIN_SUCCESS,
                payload: data,
            };
        }

        function getUpdateConfigurationAdminFailed(data) {
            return {
                type: GETUPDATECONFIGURATIONADMIN_FAILED,
                payload: data,
            };
        }
    };
export { resetGetUpdateConfigurationAdmin, getUpdateConfigurationAdminList };
